export default __webpack_public_path__ + "static/media/f5e12b067a9977ec.e8b2ed7bee8945bd556df79307be9934.svg";